"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zM9 4h2v2H9V4zm4 12H7v-1h2V8H8V7h3v8h2v1z"];
//# sourceMappingURL=info-sign.js.map